import { FaRegCheckCircle } from "react-icons/fa"

const QuotesStarter = ({ setCreateQuote }) => {
    return (
        <div className="_2fnj">
            <div className="clarions-pods">
                <h3>Close the deal</h3>
                <span className="frumpy-gel">Present your customers with an irresistible offer enclosed in quotes.!</span>
                <button onClick={() => setCreateQuote(true)}>Create New Quote</button>
            </div>
            {/* <div className="bistro-sale">
                <h3>In the Quotes section, you can:</h3>
                <div className="piecings-any">
                    <FaRegCheckCircle />
                    Customize your quote
                </div>
                <div className="piecings-any">
                    <FaRegCheckCircle />
                    Convert an accepted quote into an invoice
                </div>
                <div className="piecings-any">
                    <FaRegCheckCircle />
                    Know when an quote has been viewed, accepted, or declined
                </div>
            </div> */}
        </div>
    )
}

export default QuotesStarter

